module.exports = __webpack_public_path__ + "img/profile-dark.8fed3ae2.webp";